import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  dropzone: {
    alignItems: 'center',
    border: "1px dashed ".concat(palette.shades[500]),
    borderRadius: '2px',
    color: palette.shades[600],
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    justifyContent: 'center',
    padding: '32px 16px',
    textAlign: 'center'
  },
  dropzoneActive: {
    backgroundColor: palette.shades[200],
    borderColor: palette.primary.main
  },
  // With a file in it the box is a row, not a target, so it loses the tall padding.
  dropzoneFilled: {
    cursor: 'default',
    padding: '10px 12px'
  },
  dropzoneHint: {
    fontFamily: palette.fontFamilies.source,
    fontSize: '13px',
    maxWidth: '420px'
  },
  fileRow: {
    alignItems: 'center',
    display: 'flex',
    gap: '10px',
    width: '100%'
  },
  fileName: {
    color: palette.shades[800],
    flex: 1,
    fontFamily: palette.fontFamilies.source,
    fontSize: '14px',
    fontWeight: 600,
    overflow: 'hidden',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  error: {
    color: palette.error.main,
    fontFamily: palette.fontFamilies.source,
    fontSize: '13px',
    marginTop: '8px'
  },
  columnRow: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
    marginTop: '16px'
  },
  columnLabel: {
    color: palette.shades[600],
    fontFamily: palette.fontFamilies.poppins,
    fontSize: '11px',
    fontWeight: 600,
    letterSpacing: '0.04em',
    textTransform: 'uppercase'
  },
  columnSelect: {
    minWidth: '220px'
  },
  columnHint: {
    color: palette.shades[600],
    fontFamily: palette.fontFamilies.source,
    fontSize: '13px'
  },
  listHeader: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    margin: '20px 0 4px'
  },
  listCount: {
    color: palette.shades[700],
    fontFamily: palette.fontFamilies.source,
    fontSize: '13px'
  },
  table: {
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: '2px',
    // Tall enough for a dozen rows; a property with hundreds of units scrolls inside the box
    // rather than pushing the footer off the modal.
    maxHeight: '360px',
    overflowY: 'auto'
  },
  tableHead: {
    alignItems: 'center',
    backgroundColor: palette.shades[200],
    borderBottom: "1px solid ".concat(palette.shades[300]),
    color: palette.shades[600],
    display: 'grid',
    fontFamily: palette.fontFamilies.poppins,
    fontSize: '11px',
    fontWeight: 600,
    gap: '16px',
    gridTemplateColumns: '0.8fr 1.4fr 1fr',
    letterSpacing: '0.04em',
    padding: '8px 12px',
    position: 'sticky',
    textTransform: 'uppercase',
    top: 0,
    zIndex: 1
  },
  tableRow: {
    alignItems: 'center',
    borderBottom: "1px solid ".concat(palette.shades[250]),
    display: 'grid',
    gap: '16px',
    gridTemplateColumns: '0.8fr 1.4fr 1fr',
    padding: '8px 12px',
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  // The id that came with the chosen name, shown rather than edited.
  pickedId: {
    color: palette.shades[800],
    fontFamily: palette.fontFamilies.source,
    fontSize: '13px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  placeholder: {
    color: palette.shades[600]
  },
  unitName: {
    color: palette.shades[800],
    fontFamily: palette.fontFamilies.source,
    fontSize: '14px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
}));
export default useStyles;